import api from './api';

export type SubscriptionStatusType = 'TRIAL' | 'ACTIVE' | 'EXPIRED';

export interface SubscriptionStatus {
  status: SubscriptionStatusType;
  daysRemaining: number;
  endsAt: string | null;
  requiresAction: boolean;
}

type WrappedApiResponse<T> = {
  success: boolean;
  message: string;
  data: T;
};

const unwrap = <T>(payload: unknown): T => {
  const response = payload as WrappedApiResponse<T>;
  if (!response.success) throw new Error(response.message || 'Error en la operación');
  return response.data;
};

export const subscriptionService = {
  async getStatus(): Promise<SubscriptionStatus> {
    const res = await api.get<WrappedApiResponse<SubscriptionStatus>>('/api/subscription/status');
    return unwrap<SubscriptionStatus>(res.data);
  },
};
